/**
 * @component ContactFormPanel
 * @description 비즈니스 목적: 고객 문의 입력, 프론트 검증 표시, 제출 동작 UI를 제공합니다.
 */

import QuillEditor from '../common/QuillEditor';
import SectionHeading from '../common/SectionHeading';

export default function ContactFormPanel({
  clearPrivacyError,
  closeForm,
  errors,
  formState,
  handleChange,
  handleMessageChange,
  handleSubmit,
  inquiryTypes,
  isSubmitting,
  privacyPolicyText,
}) {
  return (
    <div className="contact-form-panel fade-in">
      <div className="contact-board-header">
        <SectionHeading
          eyebrow="Contact Form"
          title="문의 내용을 작성해주세요"
          description="작성하신 내용은 접수 후 검토하여 순차적으로 안내해드립니다."
          compact
        />
      </div>

      {/* 기능 목적: 제출 시 훅에서 프론트 검증과 API 호출을 수행합니다. */}
      <form className="contact-form" onSubmit={handleSubmit}>
        <table className="contact-form-table">
          <tbody>
            <tr>
              <th scope="row">문의 유형</th>
              <td>
                <div className="contact-form-field">
                  <select
                    className={errors.inquiryType ? 'is-error' : ''}
                    name="inquiryType"
                    value={formState.inquiryType}
                    onChange={handleChange}
                  >
                    {inquiryTypes.map((type) => (
                      <option key={type} value={type}>
                        {type}
                      </option>
                    ))}
                  </select>
                  {errors.inquiryType ? <p className="error-msg">{errors.inquiryType}</p> : null}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                제목 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td>
                <div className="contact-form-field">
                  <input
                    className={errors.title ? 'is-error' : ''}
                    name="title"
                    type="text"
                    value={formState.title}
                    onChange={handleChange}
                  />
                  {errors.title ? <p className="error-msg">{errors.title}</p> : null}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                회사명 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td>
                <div className="contact-form-field">
                  <input
                    className={errors.company ? 'is-error' : ''}
                    name="company"
                    type="text"
                    value={formState.company}
                    onChange={handleChange}
                  />
                  {errors.company ? <p className="error-msg">{errors.company}</p> : null}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                담당자명 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td>
                <div className="contact-form-field">
                  <input
                    className={errors.manager ? 'is-error' : ''}
                    name="manager"
                    type="text"
                    value={formState.manager}
                    onChange={handleChange}
                  />
                  {errors.manager ? <p className="error-msg">{errors.manager}</p> : null}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                연락처 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td>
                <div className="contact-form-field">
                  <input
                    className={errors.contact ? 'is-error' : ''}
                    name="contact"
                    type="tel"
                    value={formState.contact}
                    onChange={handleChange}
                  />
                  {errors.contact ? <p className="error-msg">{errors.contact}</p> : null}
                </div>
              </td>
            </tr>
            <tr>
              <th scope="row">
                이메일 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td>
                <div className="contact-form-field">
                  <input
                    className={errors.email ? 'is-error' : ''}
                    name="email"
                    type="email"
                    value={formState.email}
                    onChange={handleChange}
                  />
                  {errors.email ? <p className="error-msg">{errors.email}</p> : null}
                </div>
              </td>
            </tr>
            <tr className="contact-message-row">
              <th scope="row">
                문의 내용 <span className="required-mark" aria-label="필수 입력">*</span>
              </th>
              <td className="contact-message-cell">
                <div className="contact-form-field editor-field-wrapper">
                  {/* 기능 목적: 에디터 입력값을 훅 상태로 반영합니다. */}
                  <QuillEditor value={formState.message} onChange={handleMessageChange} placeholder="문의 내용을 입력해주세요." />
                  {errors.message ? <p className="error-msg">{errors.message}</p> : null}
                </div>
              </td>
            </tr>
          </tbody>
        </table>

        <hr className="section-divider" />

        <section className="privacy-section" aria-label="개인정보 처리방침 동의">
          <h3 className="privacy-title">개인정보 처리방침 동의</h3>
          <div className="privacy-box">{privacyPolicyText}</div>
          <label className="privacy-agree">
            <input
              name="privacyAgreed"
              type="checkbox"
              checked={formState.privacyAgreed}
              onChange={(event) => {
                // 기능 목적: 동의 체크 상태를 반영하고 동의 에러를 즉시 지웁니다.
                handleChange(event);
                clearPrivacyError();
              }}
            />
            개인정보 수집 및 이용에 동의합니다.
          </label>
          {errors.privacyAgreed ? <p className="error-msg">{errors.privacyAgreed}</p> : null}
        </section>

        <div className="contact-form-actions">
          <button type="submit" className="primary-button" disabled={isSubmitting}>
            {isSubmitting ? '전송 중...' : '제출'}
          </button>
        </div>
      </form>
    </div>
  );
}
